import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { queryKeyMap } from '@/features/project/_utils/query-keys';
import { ProjectsNotificationBadgeModel } from '../_models/notification';

export const useProjectNotificationBadges = ({
  id,
  enabled = true,
  refetchIntervalInMinutes,
}: {
  id: string;
  enabled?: boolean;
  refetchIntervalInMinutes?: number;
}) => {
  return useQuery({
    queryKey: queryKeyMap.projectNotification(id),
    queryFn: async () => {
      const res = await axiosGet('/api/notifications/badges/projects/', { id });
      return ProjectsNotificationBadgeModel.parse(res);
    },
    enabled: enabled && !!id,
    refetchInterval: refetchIntervalInMinutes
      ? refetchIntervalInMinutes * 60 * 1000
      : undefined,
  });
};
